module.exports = __webpack_public_path__ + "static/apart-paint-427b480f9b7ec1d0a8a241f8213a2a13.png";